'use client';!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();

import { cn } from '@qogita/ui/utils/cn'
import { BaseAnchor } from '@qogita/ui/v2/base-anchor'
import { useOptionalDrawerContext } from '@qogita/ui/v2/drawer'
import { NavigationItem } from '@qogita/ui/v2/navigation'
import { usePathname } from 'next/navigation'
import { ReactNode } from 'react'

/**
 * A navigation link that is active if the current path includes the href
 */
export function ActiveNavigationLink({
  href,
  children,
  className,
  ...props
}: {
  href: string
  children: ReactNode
  className?: string
  rumActionName?: string
}) {
  const pathname = usePathname()
  const isActive = pathname?.startsWith(href) ?? false
  const { closeDrawer } = useOptionalDrawerContext()

  return (
    <NavigationItem
      className={cn(
        // oxlint-disable-next-line shadcn/no-restyle -- grandfathered: pre-rollout restyle className on v2 component
        'flex items-center gap-3 text-gray-900 group-hover:bg-gray-50 hover:bg-gray-50 focus-visible:bg-gray-50',
        className,
      )}
      onClick={() => {
        closeDrawer()
      }}
      as={BaseAnchor}
      href={href}
      isActive={isActive}
      {...props}
    >
      {children}
    </NavigationItem>
  )
}
